import { Link } from "@mui/material";

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the Gift of Performing Arts!",
  mainCardTitle: "Share a Gift Card",
  mainCardDescription:
    "Share the magic of Grand Théâtre de Québec with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
  amountTitle: "Gift Card Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for any show sold by the Grand Théâtre de Québec box-office.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all shows sold by the Grand Théâtre de Québec box-office.",
  purchaseGiftCardSuccessLanguage: "Your purchase was successful!",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the Gift of Performing Arts!",
  mainCardTitle: "Redeem a Gift Card",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Grand Théâtre de Québec account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Grand Théâtre de Québec account.",
  successDesc: "has been added to to your account!",
  redeemGiftCardButtonLanguage: "Use your Gift Card",
};

export const purchaseSeatsLanguages = {
  registerFormTitle: "Create an Account",
  saveCardSwitchLabel: "Save card for future purchases?",
};
